module.exports = __webpack_public_path__ + "assets/img/modal-avatar-9f565341.png";